<template>
  <div class="nopads">
    <span
      v-if="showTitle"
      class="span-title"
    >{{ $t('culvert.location') }}</span>
    <span class="item-detail-text">
      <font-awesome-icon
          v-if="enableCopy && roadNumber > 0"
          id="roadAddr"
          icon="copy"
          class="ml-2 pointer text-disabled"
          @click.stop="copyRoadAddress"
      />
      {{ roadAddress }} {{ roadAddress.length > 0 ? 'm   ' : '' }} {{ showStreetName ? parsedStreet() : '' }}
    </span>
    <span class="item-detail-text">
      {{ length ? ' (' + length + ' m)' : '' }}
    </span>
  </div>
</template>

<script>
import clipboardCopy from 'clipboard-copy'
export default {
    name: 'RoadAddessView',
    props: {
        roadNumber: {
            type: Number,
            default: null
        },
        sectionNumber: {
            type: Number,
            default: null
        },
        distance: {
            type: Number,
            default: null
        },
        streetName: {
            type: String,
            default: null
        },
        city: {
            type: String,
            default: ''
        },
        enableCopy: {
            type: Boolean,
            default: true
        },
        showTitle: {
            type: Boolean,
            default: true
        },
        showStreetName: {
            type: Boolean,
            default: true
        },
        length: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            roadAddress: ''
        }
    },
    created() {
        this.generateRoadText()
    },
    methods: {
        parsedStreet() {
            let result = ''
            if (this.streetName) {
                result = this.streetName
            }
            if (this.city) {
                result += result.length > 0 ? (', ' + this.city) : this.city
            }
            if (result.length > 0 && (!this.roadNumber || this.roadNumber < 1)) {
                result += ' ' + this.$t('observations.nearest_street')
            }
            return result
        },

        generateRoadText() {
            this.roadAddress = ''
            if (this.roadNumber && this.roadNumber > 0) {
                this.roadAddress += this.roadNumber
                if (this.sectionNumber && this.sectionNumber > 0) {
                    this.roadAddress += '/ ' + this.sectionNumber
                }
            }
            if (this.distance && this.distance >= 0) {
                if (this.roadAddress.length > 0) {
                    this.roadAddress += '/ '
                }
                this.roadAddress += this.distance
            }

        },
        copyRoadAddress() {
            clipboardCopy(this.roadAddress)
        }
    }
}
</script>
